import script from "./AiBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./AiBrief.vue?vue&type=script&setup=true&lang=js"

import "./AiBrief.vue?vue&type=style&index=0&id=0572d5fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0572d5fc"]])

export default __exports__